<template>
  <div>
    <div
      ref="ruler"
      id="ruler"
      :style="{ width: rulerWidth }"
      :class="{ fullScreen: fullScreen }"
    >
      <div class="left-4 top-4 absolute text-base text-gray-300">INCHES</div>
      <div class="left-4 bottom-4 absolute text-base text-gray-300">
        CM / MM
      </div>
      <div
        v-for="line in rulerLines"
        :key="line.key"
        :class="line.class"
        :style="{ left: line.position + 'px' }"
      >
        <div v-if="line.label" :class="['number', line.labelClass]">
          {{ line.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, reactive } from "vue";

//import { computed } from "vue";
//import { useStore } from "vuex";
//import matchPlayer from "../methods";

export default {
  props: {
    dpi: Number,
    fullScreen: Boolean,
  },
  emits: ["screenText"],
  setup(props) {
    const state = reactive({
      screenText: "",
      rulerLines: [],
      rulerWidth: "0px",
    });

    let rulerLines = ref([]);

    const generateRulerLines = () => {
      //const dpi = 127.7;
      const screenWidthPixels = window.screen.width;
      const screenWidthInches = screenWidthPixels / props.dpi;
      const pixelsPerInch = screenWidthPixels / screenWidthInches;
      const pixelsPerCm = pixelsPerInch / 2.54;

      let nrulerLines = [];
      const maxPixelsForInches = 12 * props.dpi;

      for (let i = 0; i <= maxPixelsForInches; i++) {
        if (i % pixelsPerCm < 1) {
          nrulerLines.push({
            key: "cm" + i,
            class: "mark big-mark-bottom",
            position: i,
            label: (i / pixelsPerCm).toFixed(0),
            labelClass: "number-bottom",
          });
        } else if (i % (pixelsPerCm / 10) < 1) {
          nrulerLines.push({
            key: "mm" + i,
            class: "mark mark-bottom",
            position: i,
          });
        }

        if (i % pixelsPerInch < 1) {
          nrulerLines.push({
            key: "inch" + i,
            class: "mark big-mark-top",
            position: i,
            label: (i / pixelsPerInch).toFixed(0),
            labelClass: "number-top",
          });
        } else if (i % (pixelsPerInch / 12) < 1) {
          nrulerLines.push({
            key: "inch-small" + i,
            class: "mark mark-top",
            position: i,
          });
        }
      }

      //state.rulerLines = rulerLines;
      rulerLines.value = nrulerLines;
      // state.rulerWidth = `${12 * props.dpi}px`;

      //emit("screen-text", state.screenText);
    };

    // Watch for changes in props.dpi
    watch(
      () => props.dpi,
      (/*newVal, oldVal*/) => {
        //console.log("DPI prop changed from", oldVal, "to", newVal); // Debugging log
        generateRulerLines();
      },
      { deep: true, immediate: true }
    );

    return {
      screenText: state.screenText,
      rulerLines: rulerLines,
      rulerWidth: computed(() => {
        return `${12 * props.dpi}px`;
      }),
    };
  },
  methods: {
    //matchPlayer,
  },
};
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
}
/*
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
} */

/* Basic styling for the ruler */
#ruler {
  box-shadow: 1px 1px 3px rgba(148, 148, 148, 0.75);
  position: relative;
  width: 100%;
  height: 120px;
  border-top: 1px solid black;
  overflow: hidden; /* This will hide any marks that exceed the ruler's width */
  background-color: #f4f4f4; /* Light gray background for the ruler */
}
#ruler.fullScreen {
  height: 100vh;
}
/* Media query for mobile devices */
@media (max-width: 768px) and (orientation: portrait) {
  #ruler {
    box-shadow: -1px -1px 3px rgba(148, 148, 148, 0.75);
    /* Rotate the ruler to make it vertical */
    transform: rotate(90deg) translateY(-100%);
    transform-origin: top left;

    /* Set width and height to occupy full viewport height */
    /*width: 100px;
    height: 100%;*/

    /* Adjust border and positioning */
    border-top: none;
    border-left: 1px solid black;
    position: absolute;
    left: 0;
    top: 0;
    /* display: sticky; */
  }
  #ruler.fullScreen {
    height: 100vw;
  }
}

/* Styling for every centimeter mark */
.mark {
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 20px;
  background-color: black;
}

/* Styling for every 10 centimeters mark */
.big-mark {
  height: 40px; /* Make it taller than minor marks */
}

/* Styling for numbers */
.number {
  font-weight: bold;
  background: #f4f4f4;
  position: absolute;
  bottom: 5px; /* Slight spacing from the bottom */
  font-size: 16px;
  transform: translateX(-50%); /* Center the numbers */
}

/* Displaying device and screen info (optional) */
#screenInfo {
  margin-bottom: 20px;
}

.number-top {
  top: 22px;
  height: fit-content;
}

.number-bottom {
  bottom: 22px;
  height: fit-content;
}

.mark-top {
  top: 0;
  height: 10px;
}

.mark-bottom {
  bottom: 0;
  height: 10px;
}

.big-mark-top {
  top: 0;
  height: 20px;
}

.big-mark-bottom {
  bottom: 0;
  height: 20px;
}

.dark #ruler {
  /* background: black;
  https://www.toptal.com/designers/subtlepatterns/uploads/micro_carbon.png

   */
  background-image: url(https://www.toptal.com/designers/subtlepatterns/uploads/tactile_noise.png);
  background-repeat: repeat;
  background-size: auto;
}
.dark .number {
  background-image: url(https://www.toptal.com/designers/subtlepatterns/uploads/tactile_noise.png);
  background-repeat: repeat;
  background-size: auto;
  color: white;
}
.dark .mark {
  background: white;
}
</style>
